import { Observable } from 'rxjs';

export function canvasToBlob(canvas: HTMLCanvasElement, type?: string, quality?: number): Observable<Blob> {
  return new Observable<Blob>((subscriber) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          subscriber.error(new Error('Canvas to blob error'));
        } else {
          subscriber.next(blob);
          subscriber.complete();
        }
      },
      type,
      quality,
    );
  });
}
